<template>
  <tr>
    <td>
      <v-btn
        @click="doLoad(palletBreakdown)"
        :disabled="pending || isCreditHold"
        :loading="pending"
        color="green accent-4 white--text"
        width="120"
        v-if="!isLoaded"
      >
        Load
      </v-btn>
      <v-btn
        @click="doUnload(palletBreakdown)"
        :disabled="pending || isCreditHold || isUser"
        :loading="pending"
        color="red lighten-1 white--text"
        width="120"
        v-else
      >
        Unload
      </v-btn>
    </td>
    <td class="text-uppercase">{{ palletBreakdown.initials }}</td>
    <td>{{ palletBreakdown.date_scanned }}</td>
    <td>{{ palletBreakdown.time_scanned }}</td>
    <td>{{ palletBreakdown.pallet_num }}</td>
    <td>{{ palletBreakdown.quantity_per_pallet }}</td>
  </tr>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'LoadPalletBreakdown',
  computed: {
    ...mapState('dock', ['dock', 'pending']),
    ...mapGetters('auth', ['isUser']),
    isLoaded() {
      return this.palletBreakdown.pallet_loaded === 'Loaded';
    },
    customer() {
      if (this.load.salesOrder) return this.load.salesOrder.customer;
      return null;
    },
    isCreditHold() {
      return this.customer && (this.customer.creditHold || this.customer.creditHoldCOD);
    }
  },
  methods: {
    ...mapActions('dock', ['loadPallet', 'unloadPallet']),
    ...mapMutations('dock', ['setPending']),
    async doLoad(item) {
      if (this.pending) return;
      try {
        this.setPending(true);
        await this.loadPallet({
          dock_num: this.dock.number,
          pallet_num: item.pallet_num,
          sprunnuma: this.load.sprunnum
        });
        this.palletBreakdown.pallet_loaded = 'Loaded';
      } catch (ex) {
        item.pallet_loaded = 'Not Loaded';
      } finally {
        this.setPending(false);
      }
    },
    async doUnload(item) {
      if (this.pending) return;
      try {
        this.setPending(true);
        await this.unloadPallet({
          dock_num: this.dock.number,
          pallet_num: item.pallet_num,
          psonum: this.palletBreakdownHeader.psonum
        });
        this.palletBreakdown.pallet_loaded = 'Not Loaded';
      } catch (ex) {
        item.pallet_loaded = 'Loaded';
      } finally {
        this.setPending(false);
      }
    }
  },
  props: {
    load: {
      type: Object,
      required: true
    },
    palletBreakdown: {
      type: Object,
      required: true
    },
    palletBreakdownHeader: {
      type: Object,
      required: true
    },
  }
};
</script>
